define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "他のユーザーの登録",

    'incrowd_stats.num_responders': "{{num}} 専門の医療従事者",
    'incrowd_stats.num_answers': "{{num}} 回答した質問",
    'incrowd_stats.time_to_complete': "{{num}} 分で平均アンケートを完了",

    // INCROWD
    'incrowd.about': "概要",
    'incrowd.contact': "連絡先",
    'incrowd.press': "プレス",
    'incrowd.careers': "キャリア",
    'incrowd.terms': "諸条件",
    'incrowd.t_and_c': "契約条件",
    'incrowd.faq': "よくある質問",
    'incrowd.privacy': "プライバシー",
    'incrowd.copyright': "{{year}} InCrowd Inc、版権所有",
    'incrowd.blog': "ブログ",
    'incrowd.support': "サポート",
    'incrowd.info.ios': "InCrowdネットワーク内の医師が質問を仲間たちに直接送れるようになったことを知っていますか？今すぐ<InCrowd iOSアプリ>を使ってみよう！",
    'incrowd.refer': "調査を気に入っていただけましたでしょうか？クラウドに参加していただくよう<友達をご紹介>いただければ、共に10 USD（または相当額）を差し上げます。同僚の方は調査にお答えいただいた場合でも、ボーナスを受け取ることができます。",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "最小の調査で",
    'getstarted.encourage.title.two': "最大の影響力",
    'getstarted.encourage.subtitle': "簡単な調査を通じて新製品開発と患者治療に影響を与えている、数千人もの有資格の医療専門家集団に参加して支払いも受け取りましょう！",
    'getstarted.encourage.redirect_to_solutions': "医療従事者ではありませんが、 InCrowdについてもっと知りたいですか？",
    'getstarted.actions.title': "有資格の医療専門家ですか？",
    'getstarted.actions.subtitle': "今日サインアップしてヘルスケアに焦点を当てた簡単な調査に回答してお金を得ましょう",
    'getstarted.button.continue': "開始",
    'getstarted.referral': "調査に応えてお金を稼ぎ、%{{referrerName}}さんからの紹介ボーナスを受け取るにはサインアップしてください",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "アカウント作成のために情報提供をお願いします。",
    'details.profile_details': "プロフィールの情報",
    'details.address_information': "住所の情報",
    'details.professional_info': "プロフェッショナル情報",
    'details.heading.finally': "…そして遂に",
    'details.how_receive_surveys': "調査をどのように受け取りますか？",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "基本",
    'professionchoice.encourage.subtitle': "あなたの職業がありませんか？<ここから>私達にお知らせください。あなたの職業が追加された時にお知らせします。",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "身元の確認",
    'authentication.encourage.subtitle': "InCrowdはあなたの身元を確認する必要がありますが、個人情報を第三者へ開示したり提供したりすることは決してありません。",
    'authentication.actions.select_notifications': "調査の受取方法を選択してください",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "情報を検証する間、しばらくお待ちください",
    'validation.please_answer': "個人情報を検証するために、次の質問にお答えください",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "認証",
    'confirmation.validation_success.subtitle': "登録が完了しました。InCrowd!にようこそ！間もなく確認のメールやテキストメッセージが届きます！ご参加ありがとうございます！",
    'confirmation.validation_error.title': "追加情報が必要です",
    'confirmation.validation_error.subtitle': "申し訳ございません、%{userFirstName}さん。個人情報を確認する際、問題がありました。",
    'confirmation.actions_title': "次は？",
    'confirmation.go_to_your_profile': "プロフィールに移動",
    'confirmation.validation_success.actions_subtitle': "数日以内に弊社の3～5分間のマイクロ調査がメールやテキストメッセージで届き始めます。まだテキストメッセージでの調査の受信に登録していませんか？InCrowd プロフィールでいつでもコミュニケーション設定を変更することができます。",
    'confirmation.validation_error.actions_subtitle': "InCrowdチームメンバーと未解決の問題について話すには、画面右下のポップアップチャットをご使用ください。",
    'confirmation.referral.info.1': "2つ目の調査完了後%{payoutBusinessDays}営業日以内に、ご本人と紹介者の両方に<%{currency}%{referralBonusAmount}が贈られます>。%{currency}%{referralBonusAmount}はリワードアカウントに追加されます。いつでも<プロフィール>にサインインして設定を変更したりリワードを確認したり、招待を受けた回答待ちの調査にアクセスできます。",
    'confirmation.referral.info.2': "ご質問がございますか？<チャットでお問い合わせください>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "資格がありますか？",
    'regftr.markets.accepting': "InCrowd Answersは現在受付中です:",
    'regftr.peers.title': "同業者",
    'regftr.peers.subtitle': "回答に対する同業者からの反応を比較して彼らの回答から学ぶ。",
    'regftr.invites.title': "招待状",
    'regftr.invites.subtitle': "Eメールまたは電話から新しい調査への招待状を受け取って収入を最大にする。",
    'regftr.earnings.title': "収入",
    'regftr.earnings.subtitle': "収入と支払い情報を管理して追跡。",
    'regftr.stats.title': "ステータス",
    'regftr.stats.subtitle': "全ての調査情報とユーザー情報があるダッシュボードにアクセス。",

    'contextual_help.sms': "実施中のマイクロアンケートに関するSMS通知が届きます。SMSを通じ、さらに素早くアンケートを開始してさらにたくさんのリワードを獲得できるようになります。皆様の個人情報はプライベート情報として保管され、アンケートの招待のみに使われます。",
    'contextual_help.specialty': "NPI に登録されている、またはフェローシップを終えた専門、及び主な専門に含まれる医療分野のみを含めてください。後に専門を変更する場合は、support@incrowdnow.com にご連絡ください。",
    // USER
    'user(s)': "ユーザー |||| ユーザー",
    'user.login': "ログイン",
    'user.logout': "ログアウト",
    'user.register': "登録",
    'user.invitations': "招待状",
    'user.email': "Eメール",
    'user.pass_word': "パスワード",
    'user.mobile': "携帯電話",
    'user.mobile.hint': "国番号を含めてください(%{countryName}は+%{phoneCode})",
    'user.title': "敬称",
    'user.title_with_example': "敬称 (例 Dr., Ms., Mr.)",
    'user.first_name': "名",
    'user.last_name': "姓",
    'user.middle_name': "ミドルネーム",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "ユーザー",
    'user.anonymous_admin': "管理ユーザー",
    'user.dashboard': "ダッシュボード",
    'user.profile': "プロフィール",
    'user.profile.picture.upload': "プロフィール写真をアップロード",
    'user.profile.picture.change': "変更",
    'user.primary_lang': "第一言語",
    'user.primary_lang?': "第一言語は何ですか?",
    'user.survey_langs?': "流暢に話すことができる言語は何ですか？",
    'user.notify_email': "Eメールによる通知",
    'user.notify_mobile': "携帯電話による通知",
    'user.contact_support': "サポートに連絡",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "<サポートへ連絡>してください",
    'user.profession': "専門職",
    'user.profession?': "専門は何ですか？",
    'user.join_now': "今すぐ参加",
    'user.welcome_back': "また会えて嬉しいです！",
    'user.not_a_member?': "まだメンバーではありませんか？",
    'user.accept_terms': "諸条件に同意する",
    'user.accept_terms.yes': "<規約条件>に同意します",
    'user.remember_me': "このデバイスにログイン情報を記憶",
    'user.time_zone': "タイムゾーン",
    'user.payment.policy': "リワードが%{currency}25に達するごとに通知を受け、InCrowdプロフィールで支払方法を選択できます。ご質問がございますか？下のチャットウィンドウでお問い合わせください。",
    'user.country.live_work?': "居住して働いている国はどこですか？",
    // FORMS
    'form.button.back': "戻る",
    'form.button.next': "次へ",
    'form.button.cancel': "キャンセル",
    'form.button.submit': "送信",
    'form.button.continue': "続行",
    'form.button.close': "閉じる",
    'form.button.go!': "移動！",
    'form.button.complete!': "今すぐ完成させる！",
    'form.button.update': "更新",
    'form.button.finish': "終了",
    'form.button.search': "検索",
    'form.button.end': "終了",
    'form.search.no_matches': "一致するものはありません",
    'form.confirm_email': "Eメールを確認",
    'form.confirm_pass_word': "パスワードを確認",
    'form.required_fields': "必須欄",
    'form.nothing_selected': "何も選択されていません",
    'form.confirm_field': "%{formFieldName}を確認",
    'form.choice.n/a': "該当なし",
    'form.choice.yes': "はい",
    'form.choice.no': "いいえ",
    'form.choice.blank_for_all': "すべて選択するには未入力のままにしてください",
    'form.choices.select_all': "全て選択",
    'form.choices.deselect_all': "全て選択解除",
    'form.field.private': "非公開のフィールド",

    // USER ERRORS
    'user.error.dup_email': "別のユーザーが入力されたメールアドレスで既に登録しています。<ログインしますか？>",
    'user.error.dup_sms': "既に別のユーザーが同じ携帯電話番号で登録されています",
  }
})
